import { FunctionalComponentOptions } from "vue/types";
import { formatEuro } from "@/util/money";

type Props = {
    value: number | string | null | undefined;
};

export default (): FunctionalComponentOptions<Props> => ({
    functional: true,
    render(createElement, { props }) {
        return createElement("span", formatEuro(props.value));
    }
});
